import { useRouter } from 'next/router';

export default function useRestaurantSlugPrefix() {
    const router = useRouter();

    return `/restaurant/${router.query?.slug}`;
}
